"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var listViewBitFlagsUtil_1 = require("owa-bit-flags/lib/utils/listViewBitFlagsUtil");
function isDateHeaderEnabled() {
    return !listViewBitFlagsUtil_1.getIsBitSet(2 /* DateHeadersDisabled */);
}
exports.default = isDateHeaderEnabled;
//# sourceMappingURL=isDateHeaderEnabled.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-date-headers-option/lib/utils/isDateHeaderEnabled.js
// module id = 3739
// module chunks = 2